import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {
     private _tasks$$ = new BehaviorSubject(null);
     private _groups$$ = new BehaviorSubject(null);
     private _rooms$$ = new BehaviorSubject(null);
     private _coaches$$ = new BehaviorSubject(null);
     private _planning;
     private _planning$ = new BehaviorSubject(null);
     private _userBookings$ = new BehaviorSubject(null);

     didInitLoad = false;

     get tasks$() {
          return this._tasks$$.asObservable();
     }

     set tasks$(activities) {
          this._tasks$$.next(activities);
     }

     get rooms$() {
          return this._rooms$$.asObservable();
     }

     set rooms$(activities) {
          this._rooms$$.next(activities);
     }

     get coaches$() {
          return this._coaches$$.asObservable();
     }

     set coaches$(data) {
          this._coaches$$.next(data);
     }

     get groups$() {
          return this._groups$$.asObservable();
     }

     set groups$(data) {
          this._groups$$.next(data);
     }

     get planning$() {
          return this._planning$.asObservable();
     }

     set planning$(values) {
          this._planning = values;
          this._planning$.next(values);
     }

     set userBooking$(values) {
          this._userBookings$.next(values);
     }

     get userBooking$() {
          return this._userBookings$.asObservable();
     }

     clear() {
          this.userBooking$ = [] as any;
     }
     constructor() {}
}
